// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background {
  display: flex;
  flex-direction: column;
  padding-bottom: 5%;
  background: var(--backgroundColor);
}
.background .plainNavContainer {
  flex: 1 1;
  margin: 0 auto;
  width: 80%;
}
.background .plainNavbarHead {
  display: flex;
  min-width: 1200px;
  align-items: center;
}
.background .plainNavbarHead .closeIcon {
  padding: 2%;
  cursor: pointer;
}
.background .plainNavbarFooter {
  display: flex;
  margin: 20px auto 0;
  width: 80%;
  justify-content: flex-end;
}
.background .plainNavbarFooter__action {
  display: flex;
}
.background .plainNavbarFooter__cancel {
  margin-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/plainNavbar/plainNavbar.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kCAAA;AACJ;AACI;EACI,SAAA;EACA,cAAA;EACA,UAAA;AACR;AACI;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;AACR;AACQ;EACI,WAAA;EACA,eAAA;AACZ;AAEI;EACI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;AAAR;AAEQ;EACI,aAAA;AAAZ;AAGQ;EACI,kBAAA;AADZ","sourcesContent":[".background {\n    display: flex;    \n    flex-direction: column;\n    padding-bottom: 5%;\n    background: var(--backgroundColor);\n\n    .plainNavContainer {\n        flex: 1;\n        margin: 0 auto;\n        width: 80%;\n    }\n    .plainNavbarHead {\n        display: flex;\n        min-width: 1200px;\n        align-items: center;\n    \n        .closeIcon {\n            padding: 2%;\n            cursor: pointer;\n        }\n    }\n    .plainNavbarFooter {\n        display: flex;\n        margin: 20px auto 0;\n        width: 80%;\n        justify-content: flex-end;\n    \n        &__action {\n            display: flex;\n        }\n    \n        &__cancel {\n            margin-right: 20px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
